import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [modalOpen, setModalOpen] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 px-4 bg-[#0a0a0f] border-t border-white/5" data-id="element-32">
        <div className="max-w-4xl mx-auto text-center" data-id="element-33">
          <p className="text-gray-600 text-sm mb-3" data-id="element-34">
            © 2026 El Protocolo 7D de Conexión Real
          </p>
          <div className="flex items-center justify-center gap-4 text-xs" data-id="element-35">
            <button onClick={() => setModalOpen('privacy')} className="text-gray-500 hover:text-[#ff2d7a] transition-colors" data-id="element-36">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-37">|</span>
            <button onClick={() => setModalOpen('terms')} className="text-gray-500 hover:text-[#ff2d7a] transition-colors" data-id="element-38">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <AnimatePresence data-id="element-39">
        {modalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setModalOpen(null)} data-id="element-40">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} onClick={e => e.stopPropagation()} className="bg-[#1a1a24] rounded-2xl p-6 max-w-lg w-full max-h-[80vh] overflow-y-auto border border-white/10" data-id="element-41">
              <div className="flex items-center justify-between mb-4" data-id="element-42">
                <h3 className="text-xl font-serif text-white" data-id="element-43">
                  {modalOpen === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setModalOpen(null)} className="p-2 rounded-full hover:bg-white/10 transition-colors" data-id="element-44">
                  <X size={20} className="text-gray-400" data-id="element-45" />
                </button>
              </div>

              <div className="text-gray-400 text-sm space-y-4" data-id="element-46">
                {modalOpen === 'privacy' ? <>
                    <p data-id="element-47">
                      <strong className="text-white" data-id="element-48">
                        Última actualización:
                      </strong>{' '}
                      Enero 2026
                    </p>
                    <p data-id="element-49">
                      En El Protocolo 7D de Conexión Real, nos comprometemos a
                      proteger tu privacidad. Esta política describe cómo
                      recopilamos, usamos y protegemos tu información personal.
                    </p>
                    <p data-id="element-50">
                      <strong className="text-white" data-id="element-51">
                        Información que recopilamos:
                      </strong>{' '}
                      Recopilamos información que nos proporcionas directamente,
                      como tu nombre y correo electrónico al realizar una
                      compra.
                    </p>
                    <p data-id="element-52">
                      <strong className="text-white" data-id="element-53">
                        Uso de la información:
                      </strong>{' '}
                      Utilizamos tu información para procesar tu compra,
                      enviarte el producto digital y comunicarnos contigo sobre
                      tu pedido.
                    </p>
                    <p data-id="element-54">
                      <strong className="text-white" data-id="element-55">
                        Protección de datos:
                      </strong>{' '}
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado.
                    </p>
                    <p data-id="element-56">
                      <strong className="text-white" data-id="element-57">Contacto:</strong> Si
                      tienes preguntas sobre esta política, puedes contactarnos
                      a través de nuestros canales oficiales.
                    </p>
                  </> : <>
                    <p data-id="element-58">
                      <strong className="text-white" data-id="element-59">
                        Última actualización:
                      </strong>{' '}
                      Enero 2026
                    </p>
                    <p data-id="element-60">
                      Al adquirir El Protocolo 7D de Conexión Real, aceptas los
                      siguientes términos y condiciones.
                    </p>
                    <p data-id="element-61">
                      <strong className="text-white" data-id="element-62">Producto digital:</strong>{' '}
                      Este es un producto digital descargable. Una vez
                      completada la compra, recibirás acceso inmediato al
                      contenido.
                    </p>
                    <p data-id="element-63">
                      <strong className="text-white" data-id="element-64">Uso personal:</strong> El
                      contenido es para uso personal únicamente. No está
                      permitida la redistribución, reventa o compartir el
                      material con terceros.
                    </p>
                    <p data-id="element-65">
                      <strong className="text-white" data-id="element-66">
                        Propiedad intelectual:
                      </strong>{' '}
                      Todo el contenido está protegido por derechos de autor. El
                      comprador obtiene una licencia de uso personal, no la
                      propiedad del contenido.
                    </p>
                    <p data-id="element-67">
                      <strong className="text-white" data-id="element-68">
                        Política de reembolso:
                      </strong>{' '}
                      Debido a la naturaleza digital del producto, no se ofrecen
                      reembolsos una vez entregado el acceso al contenido.
                    </p>
                    <p data-id="element-69">
                      <strong className="text-white" data-id="element-70">Modificaciones:</strong>{' '}
                      Nos reservamos el derecho de modificar estos términos en
                      cualquier momento.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}